<ngx-skeleton-loader [count]="loaderSize" [loadingText]="loadingMessage"></ngx-skeleton-loader>
<div class="loading-text">{{ loadingMessage }}</div>
